var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.77304 0.84375C1.0345 0.84375 0.435791 1.44246 0.435791 2.181V13.8174C0.435791 14.8969 1.64894 15.5315 2.53569 14.9158L6.75068 11.9894C6.90063 11.8853 7.09947 11.8853 7.24942 11.9894L11.4644 14.9158C12.3512 15.5315 13.5643 14.8969 13.5643 13.8174V2.181C13.5643 1.44246 12.9656 0.84375 12.2271 0.84375H1.77304ZM12.5756 2.181V3.11499H1.42452V2.181C1.42452 1.98852 1.58056 1.83248 1.77304 1.83248H12.2271C12.4195 1.83248 12.5756 1.98852 12.5756 2.181ZM1.42452 4.10372H12.5756V13.8174C12.5756 14.0987 12.2594 14.2641 12.0283 14.1036L7.8133 11.1772C7.32428 10.8377 6.67581 10.8377 6.1868 11.1772L1.97181 14.1036C1.7407 14.2641 1.42452 14.0987 1.42452 13.8174V4.10372Z",
    fill: "#202021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.c84c319607dd4eeecb172836935b2b7c.svg";
export { ForwardRef as ReactComponent };